import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * The visual style of the Left Hand Navigation.
   * One of: "standard", "button-menu".
   */ skin: PropTypes.oneOf([
        'standard',
        'button-menu'
    ])
};
const LeftHandNavigation = createComponent({
    displayName: 'LeftHandNavigation',
    root: 'nav',
    propTypes,
    propConfig: {
        classNames (props) {
            const classesSet = new Set([
                'swan-lhn'
            ]);
            if (props.skin && props.skin !== 'standard') classesSet.add(`swan-lhn-skin-${props.skin}`);
            return classesSet;
        }
    }
});
LeftHandNavigation.defaultProps = {
    skin: 'standard'
};

export { LeftHandNavigation };
